<template>
  <div class="main-wrapper-container">
    <header-title :main-title="mainTitle" :btn-info="btnInfo" />

    <div class="logos-container">
      <div class="logo-card" v-for="item in clientLogos" :key="item.id">
        <icon-default
          class="logo-icon-edit"
          @click="editLogo(item)"
          title="Редактировать"
          :color="'dark-green'"
        >
          <IconEdit />
        </icon-default>
        <icon-default
          class="logo-icon-delete"
          @click="openModalDeleteLogo(item)"
          title="Удалить"
          :color="'dark-green'"
        >
          <IconDelete />
        </icon-default>
        <v-img
          v-if="item.logoKey"
          :src="getS3Key(item.logoKey)"
          max-width="300"
          max-height="300"
          contain
        />
        <div class="logo-name">{{ item.name }}</div>
        <div class="logo-url" v-if="item.siteUrl">{{ item.siteUrl }}</div>
        <div class="logo-sort">Сортировка: {{ item.sortOrder }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderTitle from "@/components/entities/HeaderTitle.vue";
import { mapActions, mapState } from "vuex";
import IconEdit from "@/assets/icons/ui/edit.svg?inline";
import IconDelete from "@/assets/icons/ui/delete.svg?inline";
import IconDefault from "@/components/shared/icons/IconDefault.vue";
import modalAgreement from "@/mixins/modals/modalAgreement";

export default {
  components: { IconDefault, IconDelete, IconEdit, HeaderTitle },
  mixins: [modalAgreement],
  name: "ClientLogosPage",
  data() {
    return {
      mainTitle: "Логотипы клиентов",
      btnInfo: {
        text: "Добавить логотип",
        action: () => this.openCreateLogo(),
      },
    };
  },
  computed: {
    ...mapState("clientLogos", ["clientLogos"]),
  },
  async created() {
    await this.fetchInfo();
  },
  methods: {
    ...mapActions("clientLogos", ["deleteClientLogo", "fetchClientLogos"]),
    async fetchInfo() {
      try {
        this.IS_GLOBAL_LOADING(true);
        await this.fetchClientLogos();
      } catch (e) {
      } finally {
        this.IS_GLOBAL_LOADING(false);
      }
    },
    editLogo(item) {
      this.$router.push({
        name: "client-logos-edit",
        params: { id: item.id },
      });
    },
    openCreateLogo() {
      this.$router.push({ name: "client-logos-create" });
    },
    removeLogo(item) {
      this.deleteClientLogo(item.id);
    },
    openModalDeleteLogo(item) {
      this.MODAL({
        name: 'ModalAgreement',
        title: `Удалить логотип «${item.name}»?`,
        onComplete: () => this.removeLogo(item),
      });
    },
  },
};
</script>

<style scoped lang="scss">
.logos-container {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  .logo-card {
    display: flex;
    width: 300px;
    height: 345px;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    .v-img {
      border-radius: 12px;
      border: 1px solid rgba(var(--color-grey-rgba, 1));
    }
    .logo-icon-delete {
      position: absolute;
      z-index: 1;
      right: 8px;
      top: 8px;
      cursor: pointer;
      background: rgba(var(--color-grey-rgba, 1));
      border-radius: 6px;
    }
    .logo-icon-edit {
      position: absolute;
      z-index: 1;
      right: 40px;
      top: 8px;
      cursor: pointer;
      background: rgba(var(--color-grey-rgba, 1));
      border-radius: 6px;
    }
    .logo-name {
      font-weight: 500;
      font-size: 14px;
      color: var(--color-dark-green);
    }
    .logo-url {
      width: 100%;
      border: 1px solid rgba(var(--color-grey-rgba), 1);
      border-radius: 12px;
      padding: 8px 16px;
      color: var(--color-dark-green);
      font-size: 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .logo-sort {
      font-size: 12px;
      color: rgba(var(--color-grey-rgba), 0.7);
    }
  }
}
</style>
